import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generatePDF = async (elementId, fileName = 'relatorio.pdf') => {
  const element = document.getElementById(elementId);
  
  if (!element) {
    console.error('Elemento não encontrado');
    return;
  }

  element.style.display = 'block';

  const pages = element.querySelectorAll('.print-page');
  const pdf = new jsPDF('p', 'mm', 'a4');
  
  for (let i = 0; i < pages.length; i++) {
    const page = pages[i];
    
    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    });

    const imgData = canvas.toDataURL('image/png');
    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    if (i > 0) {
      pdf.addPage();
    }

    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  }

  element.style.display = 'none';

  pdf.save(fileName);
};
